import { HttpRequest } from '@angular/common/http';
import { ConfigurationService } from 'mbs-ui-shared@services/configuration.service';

// An empty rmmWarehouse would prefix-match every URL, so it matches nothing instead
export function isRmmWarehouseRequest(req: HttpRequest<unknown>, config: ConfigurationService): boolean {
  const warehouseUrl: string = config.get('rmmWarehouse');

  return !!warehouseUrl && req.url.startsWith(warehouseUrl);
}
